<mat-form-field *ngIf="descriptor">
    <input matInput 
        [hidden]="hasProperty('hidden')"
        [type]="hasProperty('type')" 
        [readonly]="hasProperty('readOnly')"
        [placeholder]="descriptor.controlLabel" 
        [formControl]="control">
    <mat-hint *ngIf="descriptor.controlHint">{{descriptor.controlHint}}</mat-hint>
    <mat-error>
        <vedrax-validation [control]="control" [validations]="descriptor.controlValidations"></vedrax-validation>
    </mat-error>
</mat-form-field>